import { useState, useRef } from 'react';
import XTable from 'components/XTable';
import { Modal, Input, notification, Space, Button, Row, Col, Divider } from 'antd';
import {
    getMenuListApi,
    postAddMenuApi,
    getMenuApisApi,
    putMenuApisApi,
    delMenuApisApi,
} from 'api/menu';
import { getAuthListApi } from 'api/authV1';
import XForm from 'components/XForm';
const apiColumns = [
    {
        title: '接口名称',
        dataIndex: 'name',
    },
    {
        title: '接口路径',
        dataIndex: 'path',
    },
    {
        title: '请求方式',
        dataIndex: 'method',
        width: 80,
    },
];
const MenuMGT = () => {
    const xTableRef = useRef();
    const xFormRef = useRef();
    const xMenuApisTableRef = useRef();
    const xApisTableRef = useRef();
    const [addMenuVisible, setaddMenuVisible] = useState(false);
    const [addLoading, setaddLoading] = useState(false);
    const [menuApiVisible, setMenuApiVisible] = useState(false);
    const [menuname, setmenuname] = useState(false);
    const [id, setid] = useState('');
    const [menuApis, setMenuApis] = useState([]);

    const addMenu = () => {
        setaddMenuVisible(true);
    };

    // 确认新增
    const addMenuOk = () => {
        xFormRef.current.form?.submit();
    };

    // 执行新增菜单
    const onFinish = values => {
        setaddLoading(true);
        postAddMenuApi(values).then(res => {
            if (res.success) {
                notification.success({
                    message: '菜单新增成功。',
                });
                setaddMenuVisible(false);
                xTableRef.current.refreshTable && xTableRef.current.refreshTable();
            }
            setaddLoading(false);
        });
    };

    const showMenuApiModal = data => {
        const { id, name } = data;
        getRoleMenus(id);
        setid(id);
        setmenuname(name);
        setMenuApiVisible(true);
    };

    const menuApisModalCancel = () => {
        setid('');
        setmenuname('');
        setMenuApiVisible(false);
    };

    // 获取所有已设置菜单
    const getRoleMenus = id => {
        const params = {
            pageSize: 999,
            menu_id: id,
        };
        getMenuApisApi(params).then(res => {
            if (res.success) {
                const roleIds = (res.list || []).map(item => item.id);
                setMenuApis(roleIds);
            }
        });
    };

    // 添加|移除角色菜单
    const addOrDelRoleMenu = (apiId, type) => {
        const params =
            type === 'add' ? { authId: apiId, menuId: id } : { auth_id: apiId, menu_id: id };
        const api = type === 'add' ? putMenuApisApi : delMenuApisApi;
        const tipText = type === 'add' ? '添加' : '移除';
        const isDel = type === 'del';
        api(params).then(res => {
            if (res.success) {
                notification.success({
                    message: `菜单${tipText}成功`,
                });
                getRoleMenus(id);
                xMenuApisTableRef.current.refreshTable &&
                    xMenuApisTableRef.current.refreshTable(isDel);
                xApisTableRef.current.refreshTable && xApisTableRef.current.refreshTable();
            }
        });
    };

    const columns = [
        {
            title: '菜单名称',
            dataIndex: 'name',
        },
        {
            title: '菜单编码',
            dataIndex: 'code',
        },
        {
            title: '操作',
            dataIndex: '',
            render: (val, data) => {
                return (
                    <Space size="middle">
                        <span className="actionText" onClick={() => showMenuApiModal(data)}>
                            设置菜单接口
                        </span>
                    </Space>
                );
            },
        },
    ];
    const actionBtns = [{ text: '新增菜单', onClick: addMenu }];
    const formItems = [
        {
            formItemApis: {
                label: '菜单名称',
                name: 'name',
                rules: [{ required: true }],
            },
            item: <Input />,
        },
        {
            formItemApis: {
                label: '菜单编码',
                name: 'code',
                rules: [{ required: true }],
            },
            item: <Input />,
        },
    ];
    return (
        <div>
            <XTable
                columns={columns}
                api={getMenuListApi}
                rowKey="id"
                actionBtns={actionBtns}
                ref={xTableRef}
            />
            {addMenuVisible ? (
                <Modal
                    title="新增菜单"
                    centered
                    visible={addMenuVisible}
                    onOk={addMenuOk}
                    okButtonProps={{ loading: addLoading }}
                    onCancel={() => setaddMenuVisible(false)}>
                    <XForm
                        formApis={{
                            name: 'addMenu',
                            onFinish: onFinish,
                        }}
                        formItems={formItems}
                        ref={xFormRef}
                    />
                </Modal>
            ) : null}
            {id && menuApiVisible ? (
                <Modal
                    title="设置菜单接口"
                    width={1400}
                    centered
                    visible={menuApiVisible}
                    footer={[
                        <Button type="primary" onClick={menuApisModalCancel}>
                            关闭
                        </Button>,
                    ]}
                    onCancel={menuApisModalCancel}>
                    <Row gutter={24}>
                        <Col span={12}>
                            <Divider orientation="left" style={{ margin: ' 0 0 16px' }}>
                                {menuname}已设置接口
                            </Divider>
                            <XTable
                                size="small"
                                columns={[
                                    ...apiColumns,
                                    {
                                        title: '操作',
                                        dataIndex: '',
                                        fixed: 'right',
                                        width: 80,
                                        render: (val, data) => {
                                            return (
                                                <span
                                                    className="actionText"
                                                    onClick={() =>
                                                        addOrDelRoleMenu(data.id, 'del')
                                                    }>
                                                    移除
                                                </span>
                                            );
                                        },
                                    },
                                ]}
                                api={getMenuApisApi}
                                apiParams={{ menu_id: id }}
                                scrollY={'calc(100vh - 340px)'}
                                rowKey="id"
                                ref={xMenuApisTableRef}
                            />
                        </Col>
                        <Col span={12}>
                            <Divider orientation="left" style={{ margin: ' 0 0 16px' }}>
                                所有接口
                            </Divider>
                            <XTable
                                size="small"
                                columns={[
                                    ...apiColumns,
                                    {
                                        title: '操作',
                                        dataIndex: '',
                                        width: 80,
                                        fixed: 'right',
                                        render: (val, data) => {
                                            const hasId = (menuApis || []).includes(data.id);
                                            return (
                                                <span
                                                    className="actionText"
                                                    onClick={() =>
                                                        addOrDelRoleMenu(
                                                            data.id,
                                                            hasId ? 'del' : 'add',
                                                        )
                                                    }>
                                                    {hasId ? '移除' : '添加'}
                                                </span>
                                            );
                                        },
                                    },
                                ]}
                                api={getAuthListApi}
                                scrollY={'calc(100vh - 340px)'}
                                rowKey="id"
                                ref={xApisTableRef}
                            />
                        </Col>
                    </Row>
                </Modal>
            ) : null}
        </div>
    );
};
export default MenuMGT;
